
export const companyInfo = {
  name: "Gruas Asistencia",
  phone: "+34641820801",
  whatsapp: "+34641820801",
  location: "Zaragoza, España",
  email: "info@gruas-asistencia.com",
};

export const services = [
  {
    title: "Grúa para Coches",
    description: "Transporte seguro y eficiente para todo tipo de automóviles particulares en Zaragoza y alrededores.",
    icon: "Car",
  },
  {
    title: "Grúa para Motos",
    description: "Equipamiento especializado para el traslado de motocicletas sin riesgos de vuelco o daños.",
    icon: "Bike",
  },
  {
    title: "Grúa para Furgonetas",
    description: "Capacidad para vehículos de mayor tamaño y carga, ideal para flotas comerciales.",
    icon: "Truck",
  },
  {
    title: "Grúa para 4x4 y SUV",
    description: "Asistencia especializada para vehículos todoterreno y SUVs de grandes dimensiones.",
    icon: "Shield",
  },
  {
    title: "Asistencia en Carretera",
    description: "Ayuda inmediata: cambio de ruedas, arranque de batería y apertura de vehículos.",
    icon: "Wrench",
  },
  {
    title: "Transporte Nacional",
    description: "Servicio de traslado de vehículos a cualquier punto de España con máxima seguridad.",
    icon: "MapPin",
  },
];

export const reviews = [
  {
    id: 1,
    name: "Mohamed Argabi",
    rating: 5,
    text: "Muy rápido y amable. Me solucionaron el problema en cuestión de minutos.",
    date: "Hace 3 años",
  },
  {
    id: 2,
    name: "Joaquin Ribas",
    rating: 5,
    text: "Amable, rápido y con buen precio! Recomendable al 100% para cualquier urgencia.",
    date: "Hace 3 años",
  },
  {
    id: 3,
    name: "Wellington Calderón",
    rating: 5,
    text: "Muy buenos tratos y puntualidad. Llegaron exactamente cuando dijeron.",
    date: "Hace 3 años",
  },
  {
    id: 4,
    name: "Becky Prieto Soto",
    rating: 5,
    text: "Muchas gracias por haber tenido tanta paciencia y por habernos ayudado a tan altas horas, quedamos muy agradecidos.",
    date: "Hace 3 años",
  },
];

export const faqs = [
  {
    question: "¿Cómo pedir servicio de grúa en Zaragoza?",
    answer: "En caso de emergencia en carretera, contáctanos al +34 641 82 08 01 desde tu móvil o por WhatsApp. Estamos disponibles 24/7.",
  },
  {
    question: "¿Cuánto cuesta un servicio de grúa en Zaragoza?",
    answer: "El precio del servicio depende de la distancia, el tipo de vehículo y la ubicación. Llámanos para un presupuesto gratuito y sin compromiso.",
  },
  {
    question: "¿Cuánto tiempo tardará la grúa en llegar?",
    answer: "Nuestro objetivo es llegar entre 30 y 45 minutos, dependiendo de la ubicación y el tráfico en ese momento.",
  },
  {
    question: "¿Cuentan con grúas disponibles las 24 horas?",
    answer: "Sí, ofrecemos servicios de grúa 24/7, los 365 días del año, incluyendo festivos.",
  },
];

export const heroContent = {
  title: "Grúa en Zaragoza",
  subtitle: "Servicios de asistencia en carretera 24/7",
  description: "Servicio rápido, seguro y económico. Llegamos en 30-45 minutos. Transporte de coches, motos y furgonetas.",
  ctaPrimary: "Llamar Ahora",
  ctaSecondary: "WhatsApp",
};
